import React, { useCallback, useEffect, useState } from 'react'
import { DropDownMenuItems } from './DropDownMenuItems';

export const DropDownMenu = ({ show: showProp, onToggle, onClose }) => {
    const [internalShow, setInternalShow] = useState(false);
    const isControlled = typeof showProp === 'boolean';
    const show = isControlled ? showProp : internalShow;

    const closeMenu = useCallback(() => {
        if (isControlled) {
            onClose?.();
            return;
        }

        setInternalShow(false);
    }, [isControlled, onClose]);

    const toggleMenu = () => {
        if (isControlled) {
            onToggle?.();
            return;
        }

        setInternalShow((prev) => !prev);
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                closeMenu();
            }
        };

        if (show) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [show, closeMenu]);

    return (
        <div className="dropdown nxl-h-item nxl-lavel-menu">
            <button type="button" className="avatar-text avatar-md bg-primary text-white border-0" data-bs-toggle="dropdown" data-bs-auto-close="outside" onClick={toggleMenu}>
                <i className="feather-plus"></i>
            </button>
            <DropDownMenuItems show={show} onItemClick={closeMenu} />
        </div>
    )
}
